export default "__VITE_ASSET__BSSpPn____"